<template>
  <div class="relative justify-center w-16 select-none" v-if="number">
    <!-- <img
      src="https://cdn.sportsrecruits.com/assets/itg/jersey-bg-img0.svg"
      ref="jerseyImg"
      class="w-16"
    /> -->
    <Jersey class="w-16" />
    <div class="absolute top-0 flex flex-col justify-center w-full mt-6">
      <p
        class="w-full m-0 mt-1 italic font-bold text-center text-white"
        v-if="number !== null && number !== undefined && number !== ''"
        :style="`font-size: ${adjustedFontSize}px; line-height: ${targetFontSize}px;`"
      >
        {{ number.toString() }}
      </p>
    </div>
  </div>
</template>

<script>
import Jersey from "@/srui/svg/Jersey";
export default {
  components: {
    Jersey,
  },
  props: {
    number: { required: false, default: null },
    targetFontSize: { required: false, default: 40 },
    targetFontWidth: { required: false, default: 7 },
  },
  data() {
    return {
      adjustedFontSize: this.targetFontSize,
    };
  },
  mounted() {
    this.updateFontSize();
  },
  methods: {
    getTextWidth(text) {
      // if given, use cached canvas for better performance
      // else, create new canvas
      var canvas =
        this.getTextWidth.canvas ||
        (this.getTextWidth.canvas = document.createElement("canvas"));
      var context = canvas.getContext("2d");
      context.font = '"Inter", helvetica, arial, sans-serif';
      var metrics = context.measureText(text);
      return metrics.width;
    },
    updateFontSize() {
      if (this.number) {
        const width = this.getTextWidth(this.number);

        const fontSize = (this.targetFontSize * width) / this.targetFontWidth;
        this.adjustedFontSize = (
          (this.targetFontSize / fontSize) *
          this.targetFontSize
        ).toFixed(2);
      }
    },
  },
  watch: {
    number: function () {
      this.updateFontSize();
    },
  },
};
</script>

<style scoped>
</style>